module.exports = __webpack_public_path__ + "media/images/arrow-white-down-e5a8767d0b1693cfdd155783439528a8.svg";